import type { ComponentType } from 'react'
import { TeamSummaryWidget } from './TeamSummaryWidget'
import { RecentActivityWidget } from './RecentActivityWidget'
import { GenericWidget } from './GenericWidget'
import { TaskListWidget } from './TaskListWidget'
import { SubscriptionsDueWidget } from './SubscriptionsDueWidget'
import type { WidgetDefinition, WidgetPayload } from '../api/types'

export type WidgetRendererProps = {
  definition: WidgetDefinition
  payload: WidgetPayload<never>
}

/**
 * Maps a widget id to the component that draws it.
 *
 * The important part is the fallback. The backend discovers widgets from
 * whatever modules are installed, so this registry will always lag behind it -
 * a module can ship a widget before anyone writes a bespoke renderer. Unknown
 * ids fall through to GenericWidget, which renders the headline and whatever
 * shape the payload happens to be, so a new widget appears and works rather
 * than crashing the dashboard.
 */
const renderers: Record<string, ComponentType<WidgetRendererProps>> = {
  'user.team_summary': TeamSummaryWidget as ComponentType<WidgetRendererProps>,
  'activity_log.recent': RecentActivityWidget as ComponentType<WidgetRendererProps>,
  'project.my_tasks': TaskListWidget as ComponentType<WidgetRendererProps>,
  'project.overdue': TaskListWidget as ComponentType<WidgetRendererProps>,
  'subscription.due': SubscriptionsDueWidget as ComponentType<WidgetRendererProps>,
}

export function rendererFor(widgetId: string): ComponentType<WidgetRendererProps> {
  return renderers[widgetId] ?? GenericWidget
}
